import styled from "styled-components"
import padding from "@irati/ui/src/global/padding"
import {onePxThick} from "@irati/ui/src/global/elevation"
import {injectIntl} from "@irati/utils/lang"

export default injectIntl(styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  padding-left: ${padding.base};
  flex: 1 1 0;
  ${(props) => (!props.hideNormalLogin ? `
    &:before {
      content: '';
      width: 1px;
      height: calc(100% - 20px);
      background-color: rgba(140, 140, 140, 0.3);
      display: block;
      position: absolute;
      top: 10px;
      left: 0px;
    }
    &:after {
      content: '${props.formatMessage({id: "platform.selfSignUp.or"})}';
      text-transform: uppercase;
      width: 42px;
      height: 42px;
      padding: 12px 11px;
      background-color: white;
      ${onePxThick}
      border-radius: 50%;
      display: block;
      position: absolute;
      top: 50%;
      left: -21px;
      transform: translate(0, -50%);
      font-size: 12px;
      line-height: 18px;
      font-weight: bold;
    }
  ` : "")}
`)
